import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import { GetPendingUserMarketDataEntitlementDetailsUrl, GetPendingUserMarketDataEntitlementsUrl, GetUserMarketDataEntitlementsUrl, SubmitMktDataUserProfileReviewUrl } from '../constants';
import { RequestHeaders } from './utilities';
export var Entitlements = function Entitlements(api) {
  return {
    getPendingUserMarketDataEntitlements: function getPendingUserMarketDataEntitlements(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return api.authenticated().get(GetPendingUserMarketDataEntitlementsUrl, request, RequestHeaders);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    submitMktDataUserProfileReview: function submitMktDataUserProfileReview(data) {
      return api.authenticated().post(SubmitMktDataUserProfileReviewUrl, data, RequestHeaders);
    },
    getUserMarketDataEntitlements: function getUserMarketDataEntitlements() {
      return api.authenticated().get(GetUserMarketDataEntitlementsUrl, {}, RequestHeaders);
    },
    getPendingUserMarketDataEntitlementDetails: function getPendingUserMarketDataEntitlementDetails(entitlementId) {
      return api.authenticated().get(GetPendingUserMarketDataEntitlementDetailsUrl, {
        pendingId: entitlementId
      }, RequestHeaders);
    }
  };
};